module.exports = __webpack_public_path__ + "static/domki1-55196ccc3c458a39f91305f7349ad638.jpg";